import script from "./tutorProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorProfile.vue?vue&type=script&setup=true&lang=js"

import "./tutorProfile.vue?vue&type=style&index=0&id=6d7b0f60&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d7b0f60"]])

export default __exports__